"use strict";

import $ from "jquery";

const nameSpace = "carousel";

/**
 * [dataAttrOptions extends default options with options defined in namespaced data attr.]
 * @param  {object} defaults [Default extend object]
 * @param  {object} options  [Extend to defaults]
 * @return {object}          [extended object]
 */
export function dataAttrOptions(defaults, options) {
    const dataOptions = {};
    let settings = {};

    if ($.isEmptyObject(options)) {
        return defaults;
    }

    for (const key in options) {
        if (key.includes(nameSpace)) {
            const stripedKey = key.replace(nameSpace, "");
            const newKey = stripedKey[0].toLowerCase() + stripedKey.slice(1);

            dataOptions[newKey] = options[key];
        }
    }

    // Recursively merge defaults and data attribute options.
    settings = $.extend(true, {}, defaults, dataOptions);

    return settings;
}
